 import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import { DescriptionCell, ItemDetailLeftPanel, ItemDetailRightPanel, LabelCell } from "../../../shared/styles";

const DetailSection: FC = () => {
  const row = (label: string, rightColumn: string | React.ReactNode): React.ReactNode => {
      return (
          <FlexContainer className="label-description-row">
              <LabelCell>
                  <CustomLabel>{label}</CustomLabel>
              </LabelCell>
              <DescriptionCell>{rightColumn}</DescriptionCell>
          </FlexContainer>
      );
  };

  return (
      <FlexContainer padding="40px 0px 0px" className="bg-white">
          <ItemDetailLeftPanel>
              {row('Status', 'Sale')}
              {row('Order No', '229')}
              {row('Created Date', 'September 17, 2023')}
              {row('Created By', 'Jeff Cohen')}
              {row('Reference', '20103')}
              {row('Order ID', 'ORD_DK10383A')}
              {row('Payment Method', 'Visa - ****4422')}
              {row('Merchant Account', 'School Operating Account')}
          </ItemDetailLeftPanel>
          <ItemDetailRightPanel>
              {row(
                  'Bill To',
                  <>
                      Jill Hawthorne\n123 Main Street,
                      <br /> Suite 100\nPhiladelphia,
                      <br /> PA 19132
                  </>,
              )}
              {row(
                  'Ship To',
                  <>
                      Jim Hawthorne\n650 Broad Street,
                      <br /> Apt 100\nAbigon,
                      <br /> PA 19001
                  </>,
              )}
              {row(
                  'Used By',
                  <>
                      Bert Hawthorne,
                      <br /> John Hawthorne
                  </>,
              )}
          </ItemDetailRightPanel>
      </FlexContainer>
  );
};
export default DetailSection;
